import React, { useEffect, useState } from 'react';
import { FeedbackSystem } from '../components/reuse/feedback/FeedbackSystem';

export function FeedbackPage() {
  const [providerId, setProviderId] = useState(null);
  const [patientName, setPatientName] = useState('');

  // Extract providerId and patientName from URL query parameters on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Get providerId
    const providerIdParam = urlParams.get('providerId');
    if (providerIdParam) {
      console.log('Provider ID from URL:', providerIdParam);
      setProviderId(providerIdParam);
    }
    
    // Get patientName
    const patientNameParam = urlParams.get('patientName');
    if (patientNameParam) {
      console.log('Patient name from URL:', decodeURIComponent(patientNameParam));
      setPatientName(decodeURIComponent(patientNameParam));
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* <div className="text-center mb-12">
          <img
            src="https://images.unsplash.com/photo-1651008376811-b90baee60c1f?auto=format&fit=crop&q=80&w=150&h=150"
            alt="Medical Practice Logo"
            className="mx-auto h-24 w-24 rounded-full object-cover mb-4"
          />
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Dr. Smith's Medical Practice
          </h1>
          <p className="text-lg text-gray-600">
            We value your feedback! Please share your experience with us.
          </p>
        </div> */}

        <FeedbackSystem providerId={providerId} patientName={patientName} />
      </div>
    </div>
  );
}